import React, { useState, useEffect } from "react";



import {useNavigate, useLocation} from 'react-router-dom';
import emailjs from "emailjs-com";


const FormData = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  const [data, setData] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
    comment: "",
    currency: "",
    departureDate: "",
    departureTime: "",
    country: "",
    from: "",
    isReturn: "",
    returnDate: "",
    returnTime: "",
    to: "",
    vehicles: "",
    price: "",
    flightNumber: "",
    airline: "",
    paymentMethod: "",
  });

  const [storageForm, setStorageForm] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const res = JSON.parse(localStorage.getItem("formData")) || {};
    setStorageForm(res);
  }, []);

  useEffect(() => {
    setData({
      ...data,
      currency: storageForm?.currency || "",
      departureDate: storageForm?.departureDate || "",
      departureTime: storageForm?.departureTime || "",
      from: storageForm?.from || "",
      isReturn: storageForm?.isReturn || "",
      returnDate: storageForm?.returnDate || "",
      returnTime: storageForm?.returnTime || "",
      to: storageForm?.to || "",
      vehicles: storageForm?.vehicles || "",
      price: storageForm?.price || "",
    });
  }, [storageForm]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

const handleSubmit = async (event) => {
  event.preventDefault();
  setLoading(true);

  try {
     // =============================
    // BLOQUES CONDICIONALES
    // =============================
   const returnBlock =
  data.isReturn === true || data.isReturn === "true"
    ? `
      <li>Return date: ${data.returnDate}</li>
      <li>Return time: ${data.returnTime}</li>
    `
    : "";


    const commentBlock = data.comment ? `<li>Comment: ${data.comment}</li>`: "";

    const extraInfo = returnBlock + commentBlock;

    // =============================
    // EMAIL AL ADMIN
    // =============================
    await emailjs.send(
      "service_fmd070b",
      "template_gsc94a1",
      {
        name: data.name,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
        country: data.country,
        airline: data.airline,
        flightNumber: data.flightNumber,
        from: data.from,
        to: data.to,
        vehicles: data.vehicles,
        departureDate: data.departureDate,
        departureTime: data.departureTime,
        extra_info: extraInfo,
        price: data.price,
        currency: data.currency,
      },
      "qDNs-GIZtOyJhXiB4"
    );

    // =============================
    // EMAIL AL CLIENTE
    // =============================
   await emailjs.send(
      "service_fmd070b",
      "template_0f71e3n",
      {
        name: data.name,
        email: data.email,
      },
      "qDNs-GIZtOyJhXiB4"
    );

    localStorage.removeItem("formData");
    navigate("/reservate-success");

  } catch (error) {
    console.error("EmailJS error:", error);
    alert("There was an error sending the reservation.");
  } finally {
    setLoading(false);
  }
};


  const back = () => {
    window.history.back()
    localStorage.removeItem("formData");
  }
  return (
    <div className="form-payment-container">
      <button
        type="button"
        className="back-button"
        onClick={back}
      >
        Go Back
      </button>
      <div className="form-title">
        <strong>Datos personales</strong>
        <hr />
      </div>
      <form onSubmit={handleSubmit} className="form">
        <div className="form-section">
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name:</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={data.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone:</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={data.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">Country:</label>
            <input
              type="text"
              id="country"
              name="country"
              value={data.country}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="airline">Airline:</label>
            <input
              type="text"
              id="airline"
              name="airline"
              value={data.airline}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="flightNumber">Flight Number:</label>
            <input
              type="text"
              id="flightNumber"
              name="flightNumber"
              value={data.flightNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="comment">Comments:</label>
            <textarea
              id="comment"
              name="comment"
              value={data.comment}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>

        <div className="button-container">
          <button
            className="btn btn-primary w-100 py-2"
            disabled={loading}
            type="submit"
          >
            {loading ? "Loading..." : "Book Now"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormData;
